/**
 * Flatten markdown to clean plain text for the single-line conversation-list
 * preview (the truncated snippet under each customer name). The message thread
 * renders full markdown via `InboxMessageContent`; the preview should not show
 * raw `**`, backticks, or `[label](url)` syntax.
 */
export function toPreviewText(content: string): string {
  return content
    .replace(/```[\s\S]*?```/g, ' ') // fenced code blocks
    .replace(/`([^`]+)`/g, '$1') // inline code
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ') // images
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links → label
    .replace(/^#{1,6}\s+/gm, '') // headings
    .replace(/^[>\-*+]\s+/gm, '') // blockquote / list markers
    .replace(/\*\*([^*]+)\*\*/g, '$1') // bold **
    .replace(/__([^_]+)__/g, '$1') // bold __
    .replace(/\*([^*]+)\*/g, '$1') // italic *
    .replace(/~~([^~]+)~~/g, '$1') // strikethrough
    .replace(/\s+/g, ' ') // collapse whitespace/newlines
    .trim()
}

/** SA-1127: an email block's direction mark, as a screen reader names it. */
export const EMAIL_RECEIVED = 'Received'
export const EMAIL_SENT = 'Sent'
